import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import querystringify from 'tricks/string/querystringify';
import queryparse from 'tricks/string/queryparse';
import filterObject from './filterObject';

// Constructs a compatible Link object, given a location and an object containing the query params
export default function createLocation(location) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var
  // Object to construct the `search` option for
  state = arguments.length > 2 ? arguments[2] : undefined;
  var
  // Object of location state
  hash = arguments.length > 3 ? arguments[3] : undefined;
  // Get pathname
  var pathname = typeof location === 'string' ? location : location.pathname;

  // Default search
  var search = _typeof(location) === 'object' && location.search ? queryparse(location.search) : {};
  var newLocation = {
    pathname: pathname,
    search: "?".concat(querystringify(filterObject(_objectSpread(_objectSpread({}, search), query)))),
    state: undefined,
    hash: hash ? "#".concat(querystringify(hash)) : ''
  };
  if (state) {
    newLocation.state = state;
  }
  return newLocation;
}